import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface FeatureFlag {
  module_key: string;
  label: string;
  is_enabled: boolean;
  updated_at: string;
}

export function useFeatureFlags() {
  return useQuery({
    queryKey: ["feature-flags"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("feature_flags")
        .select("*")
        .order("label");
      if (error) throw error;
      return data as FeatureFlag[];
    },
  });
}

export function useToggleFeatureFlag() {
  const queryClient = useQueryClient();
  const { refreshFeatureFlags } = useAuth();
  return useMutation({
    mutationFn: async ({ moduleKey, enabled }: { moduleKey: string; enabled: boolean }) => {
      const { error } = await supabase
        .from("feature_flags")
        .update({ is_enabled: enabled })
        .eq("module_key", moduleKey);
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["feature-flags"] });
      // The sidebar reads AuthContext's copy, not this query (#700).
      void refreshFeatureFlags();
    },
  });
}
